<template>
    <div class="cookie">
        <div id="cookie" class="cookie beige">
            <div class="container" v-if="this.dataLoaded">
                <div>
                    <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" >{{page.attributes.title}}</h1>
                </div>
                <div>
                    <p v-html="this.page.attributes.field_description.processed"></p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'cookie-policy',
    props: {
        dataPages: {
            type: String
        },
        parentLang: {
            type: String
        }
    },
    data:()=>{
        return {
            idIntroPage:"80b595cc-2588-4f24-ad15-6e407894724b",
            page:[],
            dataLoaded:false,
            lang:"it",
            langData: "it",
        }
    },
    methods:{
        findObjectbyKey:(array, key, value)=>{
            for (var i = 0; i < array.length; i++) {
                if (array[i][key] === value) {
                    return array[i];
                }
            }
            return null;
        },
        fetchData: function () {
            const jsondaSistemare = "https://ptnlex-api.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page"
            fetch(jsondaSistemare, {method: "GET", mode: 'cors'})
            .then(response=>{
                return response.json()
            })
            .then(json=>{
                this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
                this.dataLoaded = true
            })
            .catch(function(error) {  
                console.log('Request failed', error)  
            });
        }
    },
    watch:{
        $route (){
            if(this.$route.params.lang == "en"){
                this.langData = "en"
            } else {
                this.langData = "it"
            }
            this.fetchData()
            }, 
    },
    created(){        
        this.fetchData()
        window.scrollTo(0,0)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">

</style>
